import styles from "./link.module.scss";
import classnames from "classnames";
import PropTypes from "prop-types";

export const Link = ({ children, disabled, hidden, href, ...rest }) => {
  if (hidden) return null;

  return (
    <a
      className={classnames(styles.link, {
        [styles.disabled]: disabled || (!href && !rest.onClick),
        [styles.external]: rest.external,
      })}
      href={href}
      onClick={(e) => {
        e.stopPropagation();
        if (typeof rest.onClick === "function") {
          rest.onClick(e);
        }
      }}
      rel="noopener noreferrer"
      target="_blank"
    >
      {children}
    </a>
  );
};

Link.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  hidden: PropTypes.bool,
  href: PropTypes.string.isRequired,
};
